import { memo } from 'react';
import { Box } from '@bonanza-social/moonlight';
import { STYLES } from './PrizeWallPrizeBackground.content';
import { PrizeWallPrizeBackgroundProps } from './PrizeWallPrizeBackground.types';

function PrizeWallPrizeBackground({
  variant,
  animatedStyle,
}: PrizeWallPrizeBackgroundProps) {
  return (
    <Box
      inset={0}
      overflow="hidden"
      position="absolute"
      borderRadius="radius-200"
      animatedStyle={animatedStyle}
      {...STYLES[variant]}
    >
      {variant === 'awarded' && (
        <Box
          inset={0}
          position="absolute"
          variant="gradient"
          gradient="warmUpBackground"
        />
      )}
    </Box>
  );
}

export default memo(PrizeWallPrizeBackground);
